import PropTypes from 'prop-types';
import React from 'react';

import InterviewType from '../../../domain/InterviewType';
import Necessities, { NecessitiesType } from '../../../domain/Necessities';
import AccessIcon from '../../atoms/AccessIcon';
import BelongingsIcon from '../../atoms/BelongingsIcon';
import BuildingIcon from '../../atoms/BuildingIcon';
import CalendarIcon from '../../atoms/CalendarIcon';
import ClothesIcon from '../../atoms/ClothesIcon';
import ContentIcon from '../../atoms/ContentIcon';
import MapIcon from '../../atoms/MapIcon';
import MoneyIcon from '../../atoms/MoneyIcon';
import PersonIcon from '../../atoms/PersonIcon';
import ReferAccess from '../../organisms/reservation/ReferAccess';

import '../../../css/style.css';

class ReservationPublic extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      match: PropTypes.shape({
        params: PropTypes.shape({
          id: PropTypes.string,
          type: PropTypes.string,
        }),
      }),
      fetchDetailForPublic: PropTypes.func,
      state: PropTypes.shape({
        isLoading: PropTypes.bool,
        reservationRefer: PropTypes.shape({
          id: PropTypes.string,
          date: PropTypes.string,
          name: PropTypes.string,
          isDisplaySeat: PropTypes.bool,
          seatAvailability: PropTypes.string,
          seat: PropTypes.number,
          status: PropTypes.string,
          isPaid: PropTypes.bool,
          price: PropTypes.number,
          hallName: PropTypes.string,
          hallAddress: PropTypes.string,
          access: PropTypes.array,
          accessMapUrl: PropTypes.string,
          contents: PropTypes.string,
          chargeStaffName: PropTypes.string,
          belongings: PropTypes.string,
          clothes: PropTypes.string,
          isCancel: PropTypes.bool,
          webInterviewURL: PropTypes.string,
          defaultMessage: PropTypes.string,
          eventMethodTypeName: PropTypes.string,
          webEventURL: PropTypes.string,
          isClothesNormal: PropTypes.bool,
          nearestStation: PropTypes.string,
          clothesOther: PropTypes.string,
          isBelongingsNormal: PropTypes.bool,
          belongingsOther: PropTypes.string,
          eventType: PropTypes.string,
        }),
      }),
      history: PropTypes.shape({
        push: PropTypes.func,
      }),
    };
  }

  componentDidMount() {
    const { params } = this.props.match;
    this.id = params.id;
    console.log('Props state:', this.props.state);
    console.log('Params:', params);
    this.props.fetchDetailForPublic(this.id);
  }

  render() {
    const getName = () => {
      return new InterviewType(this.props.state.reservationRefer.name)
        .displayName;
    };

    const getOpenDate = () => {
      return this.props.state.reservationRefer.date;
    };

    const isSeatAvailability = () => {
      return false;
    };

    const getSeatAvailability = () => {
      return `${this.props.state.reservationRefer.seat}/${this.props.state.reservationRefer.seatAvailability}`;
    };

    const isPrice = () => {
      return false;
    };

    const getPrice = () => {
      return this.props.state.reservationRefer.price;
    };

    const getUrl = () => {
      const reservationRefer = this.props.state.reservationRefer;
      return reservationRefer.webInterviewURL || '';
    };

    const isOnline = () => {
      const reservationRefer = this.props.state.reservationRefer;
      return String(reservationRefer.name) === 'Web面談';
    };

    const getHallName = () => {
      const reservationRefer = this.props.state.reservationRefer;

      if (reservationRefer.hallName && reservationRefer.hallName.length > 0) {
        return reservationRefer.hallName;
      }

      if (
        reservationRefer.defaultMessage &&
        reservationRefer.defaultMessage.length > 0
      ) {
        return reservationRefer.defaultMessage;
      }

      return '';
    };

    const existsVenueAddress = () => {
      return (
        this.props.state.reservationRefer.hallAddress &&
        this.props.state.reservationRefer.hallAddress.length > 0
      );
    };

    const getHallAddress = () => {
      return this.props.state.reservationRefer.hallAddress;
    };

    const existsAccess = () => {
      return (
        this.props.state.reservationRefer.access &&
        this.props.state.reservationRefer.access.length > 0
      );
    };

    const getNearestStation = () => {
      return this.props.state.reservationRefer.nearestStation;
    };

    const getAccessList = () => {
      return this.props.state.reservationRefer.access;
    };

    const isDisplayContents = () => {
      return false;
    };

    const getContents = () => {
      return this.props.state.reservationRefer.contents;
    };

    const getClothes = () => {
      if (this.props.state.reservationRefer.isClothesNormal) {
        return '自由';
      }
      return this.props.state.reservationRefer.clothesOther;
    };

    const getBelongings = () => {
      let necessitiesType;
      if (this.props.state.reservationRefer.isBelongingsNormal) {
        necessitiesType = new NecessitiesType.Default();
      } else {
        necessitiesType = new NecessitiesType.Other(
          this.props.state.reservationRefer.belongingsOther
        );
      }

      return new Necessities(necessitiesType, isOnline()).displayName;
    };

    const getAccessImageMapUrl = () => {
      const access = (this.props.state.reservationRefer.access || [])[0];

      if (access && Object.hasOwnProperty.call(access, 'accessMapUrl')) {
        return `${process.env.REACT_APP_API_URI}/${access.accessMapUrl}`;
      }

      return null;
    };

    const getAccessMapUrl = () => {
      return this.props.state.reservationRefer.accessMapUrl;
    };

    const getIFlameUrl = () => {
      return (
        'https://www.google.com/maps?q=' + getHallAddress() + '&output=embed'
      );
    };

    const getEventType = () => {
      return this.props.state.reservationRefer.eventType;
    };

    const styles = { whiteSpace: 'pre-line' };
    // const padding = { padding: }

    return (
      <>
        {!this.props.state.isLoading ? (
          <section className="section" style={{ padding: '2rem 1.5rem 4rem' }}>
            <h2 className="c-lead -with-back">
              <span>{getName()}</span>
            </h2>

            <div className="p-detail_info">
              <dl className="-center">
                <dt className="-calendar">
                  <CalendarIcon />
                  開催日時
                </dt>
                <dd>
                  <div className="-col">
                    <span>{getOpenDate()}</span>
                    <div className="-col"></div>
                  </div>
                </dd>
              </dl>

              {isSeatAvailability() ? (
                <dl>
                  <dt className="-numbers">
                    <PersonIcon />
                    定員
                  </dt>
                  <dd>
                    <span className="u-disp-ib">{getSeatAvailability()}</span>名
                  </dd>
                </dl>
              ) : (
                <></>
              )}

              {getEventType() !== 'interview' && (
                <dl>
                  <dt className="-money">
                    <MoneyIcon />
                    料金
                  </dt>
                  <dd>{isPrice() ? getPrice() + '円' : '無料'}</dd>
                </dl>
              )}

              <dl>
                <dt className="-building">
                  <BuildingIcon />
                  開催場所
                </dt>
                <dd>
                  {getHallName()}
                  {isOnline() ? (
                    <>
                      {getUrl() !== '' ? (
                        <p>
                          <a
                            href={getUrl()}
                            className="c-txt_link"
                            rel="noreferrer noopener"
                            target="_blank"
                          >
                            {getUrl()}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 14 14"
                            >
                              <path
                                className="cls-1 -color"
                                d="M12,0H6A2,2,0,0,0,4,2V4H2A2,2,0,0,0,0,6v6a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2V10h2a2,2,0,0,0,2-2V2A2,2,0,0,0,12,0ZM8,12H2V6H8v6Zm4-4H10V6A2,2,0,0,0,8,4H6V2h6Z"
                              />
                            </svg>
                          </a>
                        </p>
                      ) : (
                        <>
                          <p>URLは予約日前日に表示されます</p>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </dd>
              </dl>

              {getAccessList().length > 0 && (
                <dl>
                  <dt className="-access">
                    <AccessIcon />
                    アクセス
                  </dt>
                  <dd>
                    <span>{getNearestStation()}</span>
                    {existsAccess() && (
                      <ReferAccess accessList={getAccessList()} />
                    )}
                  </dd>
                </dl>
              )}

              {existsVenueAddress() ? (
                <dl>
                  <dt className="-location">
                    <MapIcon />
                    会場住所
                  </dt>

                  <dd>
                    <span>{getHallAddress()}</span>
                    <a
                      href={getAccessMapUrl()}
                      className="c-txt_link"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <span>
                        {getAccessMapUrl()}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 14 14"
                        >
                          <path
                            className="cls-1 -color"
                            d="M12,0H6A2,2,0,0,0,4,2V4H2A2,2,0,0,0,0,6v6a2,2,0,0,0,2,2H8a2,2,0,0,0,2-2V10h2a2,2,0,0,0,2-2V2A2,2,0,0,0,12,0ZM8,12H2V6H8v6Zm4-4H10V6A2,2,0,0,0,8,4H6V2h6Z"
                          />
                        </svg>
                      </span>
                    </a>
                    <div className="-map">
                      <img src={getAccessImageMapUrl()} />
                      {existsVenueAddress() && <iframe src={getIFlameUrl()} />}
                    </div>
                  </dd>
                </dl>
              ) : (
                <></>
              )}
              {isDisplayContents() ? (
                <dl>
                  <dt className="-contents">
                    <ContentIcon />
                    内容
                  </dt>
                  <dd>
                    <span style={styles}>{getContents()}</span>
                  </dd>
                </dl>
              ) : (
                <></>
              )}
              <dl>
                <dt className="-contents">
                  <ClothesIcon />
                  服装
                </dt>
                <dd>
                  <span style={styles}>{getClothes()}</span>
                </dd>
              </dl>
              <dl>
                <dt className="-contents">
                  <BelongingsIcon />
                  持ち物
                </dt>
                <dd>
                  <span style={styles}>{getBelongings()}</span>
                </dd>
              </dl>
            </div>
          </section>
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default ReservationPublic;
